import React from 'react';
import { classNames } from 'primereact/utils';

export const FormField = ({
  label,
  htmlFor,
  required = false,
  hint,
  children,
  className,
}) => {
  return (
    <div className={classNames('cm-form-field', className)}>
      {label && (
        <label htmlFor={htmlFor} className="cm-form-label">
          {required && <i className="text-red-400 pi pi-check mr-1" aria-hidden />}
          {label}
        </label>
      )}
      {hint && <small className="cm-form-hint">{hint}</small>}
      <div className="cm-form-control">{children}</div>
    </div>
  );
};
